<script>
  import {fade} from 'svelte/transition';
  import {onMount, onDestroy} from 'svelte';
  import {fadeScale} from "../transition/fadeScale";

  export let visible = false;
  export let message;
  export let onConfirm;
  export let onCancel;
  export let okColor;
  export let cancelColor;
  export let okText;
  export let cancelText;

  const onKeyDown = e => {
    if (e.key === 'Escape') {
      onCancel();
    }

    if (e.key === 'Enter') {
      onConfirm();
    }
  };

  onMount(() => {
    window.addEventListener('keydown', onKeyDown);
  });

  onDestroy(() => {
    window.addEventListener('keydown', onKeyDown);
  });


</script>

{#if visible}
  <div class="mask" transition:fade={{duration: 200}}/>
{/if}


{#if visible}
  <!-- wrap content to prevent weird transition, since fadeScalee uses transform -->
  <div class="content-wrapper" style="width: {Math.min(400, window.innerWidth * 0.8)}px;">
    <column class="content" transition:fadeScale={{
      duration: 150,
      scale: 0.8
    }}>
      <flex class="message center">{message}</flex>
      <row class="buttons">
          {#if onCancel}
            <button class="expand" on:click={onCancel} style="color: {cancelColor};">{cancelText}</button>
          {/if}

        <button class="expand" on:click={onConfirm} style="color: {okColor};">{okText}</button>
      </row>
    </column>
  </div>
{/if}

<style>

  .mask {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
  }

  .content-wrapper {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .message {
    padding: 16px;
  }

  .content {
    width: 100%;
    line-height: 1.5em;
    background-color: white;
  }

  .buttons {
    border-top: 1px solid #efefef;
  }

  button {
    background: none;
    border: none;
    height: 32px;
  }

</style>